import { render } from "./Upload.vue?vue&type=template&id=a3d51590&scoped=true"
import script from "./Upload.vue?vue&type=script&lang=js"
export * from "./Upload.vue?vue&type=script&lang=js"

import "./Upload.vue?vue&type=style&index=0&id=a3d51590&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-a3d51590"

export default script